import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-reassign-button',
  templateUrl: './reassign-button.component.html',
  styleUrls: ['./reassign-button.component.scss'],
  imports: [MatIcon, TranslateModule, MatMenuItem, MatIconButton, MatTooltip],
})
export class ReassignButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
